import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import '../css/WhatsAppButton.css';

const WHATSAPP_PHONE = '37491407038';

const WhatsAppButton = ({ phoneNumber = WHATSAPP_PHONE }) => {
  const { t } = useTranslation();

  const message = t('whatsapp_message');
  const tooltipText = t('whatsapp_tooltip');
  const waUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <aside className="wa-floating-btn-container" aria-label="WhatsApp Contact">
      <a
        href={waUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="wa-action-wrapper"
        aria-label={tooltipText}
        title={tooltipText}
      >
        <div className="wa-tooltip-pill">
          <span className="wa-status-dot" aria-hidden="true" />
          <span className="wa-tooltip-text">{tooltipText}</span>
        </div>

        <div className="wa-floating-btn">
          <span className="wa-pulse-ring" aria-hidden="true" />
          <FaWhatsapp size={30} />
        </div>
      </a>
    </aside>
  );
};

export default WhatsAppButton;
